import { render, staticRenderFns } from "./CoursePerformance.vue?vue&type=template&id=5bd28762&"
import script from "./CoursePerformance.vue?vue&type=script&lang=js&"
export * from "./CoursePerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports